<div class="ph-input">
  <div *ngIf="hint" class="ph-input__hint">
    <span class="text--primary-light" (click)="showHint = !showHint">Help</span>

    <div
      #hint{{labelId}}
      [innerHTML]="hint"
      class="ph-input__hint__tooltip"
      [class.show]="showHint"
    ></div>
  </div>
  <div class="ph-input__wrapper" [ngClass]="classControl | async">
    <div
      *ngIf="
        type === 'checkbox';
        else type === 'select' ? select : type === 'radio' ? radio : texts
      "
    >
      <app-ph-checkbox
        [id]="name"
        [disabled]="disabled"
        [showControl]="showControl"
        [formEl]="formEl"
      >
        <ng-content></ng-content>
      </app-ph-checkbox>
    </div>
    <ng-template #select>
      <ng-select
        [items]="selectArray"
        [closeOnSelect]="closeOnSelect"
        class="ph-select"
        [ngClass]="{ disabled: disabled, 'ph-select--white': isWhite }"
        [bindLabel]="bindLabel"
        [searchable]="searchable"
        [clearSearchOnAdd]="true"
        [placeholder]="placeholder"
        [multiple]="selectMultiple"
        [bindValue]="bindValue"
        [formControl]="formEl"
        [addTag]="selectCustomTagOption"
        [addTagText]="selectCustomTagOptionText"
        [maxSelectedItems]="maxSelectedItems"
        [dropdownPosition]="dropdownPosition"
        (change)="valueChanged.emit()"
        [clearable]="clearable"
      >
        <ng-template *ngIf="isLanguage" ng-option-tmp let-item="item" let-index="index">
          <img class="list__lang" [src]="item.flagSrc" alt="flag" />
          <span>{{ item.code }}</span>
        </ng-template>
      </ng-select>
    </ng-template>
    <ng-template #radio>
      <input type="hidden" [formControl]="formEl" />
      <ng-content select="app-ph-radio, .wrapper_app-ph-radio"></ng-content>
    </ng-template>
    <ng-template #texts>
      <label [for]="labelId">
        <span class="ph-input__icon" *ngIf="icon" [ngClass]="'ph-input__icon-' + icon"></span>
        <span class="ph-input__label">{{ placeholder }}</span>
      </label>
      <textarea
        *ngIf="
          type === 'textarea';
          else type === 'datepicker'
            ? datepicker
            : type === 'googleAutocomplete'
            ? googleAutocomplete
            : input
        "
        (focus)="toggleFocus(true)"
        (blur)="toggleFocus(false)"
        class="form__control"
        [class]="styletype"
        [id]="labelId"
        [disabled]="disabled"
        [formControl]="formEl"
        [ngClass]="{ 'form__control--touched': formEl?.errors && formEl?.errors?.required }"
      ></textarea>
      <ng-template #googleAutocomplete>
        <app-ph-autocomplete-google-map
          [id]="labelId"
          [inputDefaultValue]="googleAutocompleteDefaultValue"
          (placeChanged)="placeChanged($event)"
          [formControl]="formEl"
        >
        </app-ph-autocomplete-google-map>
      </ng-template>
      <ng-template #input>
        <input
          [type]="type"
          [autocomplete]="autocomplete"
          (focus)="toggleFocus(true)"
          (blur)="toggleFocus(false)"
          [id]="labelId"
          [attr.min]="type === 'number' ? min : null"
          class="form__control"
          (keypress)="validationType($event)"
          (keyup.enter)="emitKeyUpEnter()"
          [disabled]="disabled"
          #inputEl
          [formControl]="formEl"
        />
        <span
          class="ph-input__password-show"
          *ngIf="saveType === 'password'"
          (click)="toggleShowPassword()"
        ></span>
      </ng-template>
      <ng-template #datepicker>
        <app-ph-datepicker
          [initValue]="initValue"
          [correctForm]="formEl"
          ngDefaultControl
          [labelId]="labelId"
          [extraOptions]="extraOptions"
          [datepickerReadOnly]="datepickerReadOnly"
          [disableDatepickerIcon]="disableDatepickerIcon"
          #phDatepicker
          [formControl]="formEl"
          (phDatepickerChange)="updateForm($event)"
        ></app-ph-datepicker>
      </ng-template>
    </ng-template>
  </div>
  <div
    class="form__rules"
    [ngClass]="{ 'form__rules--empty': !formEl.value }"
    *ngIf="errorDescription"
  >
    <ul class="list list--rules list--columns list--columns-2">
      <li
        class="list__item"
        [ngClass]="{
          'list__item--danger': oneCapitalLetter,
          'list__item--success': !oneCapitalLetter
        }"
      >
        {{ 'VALIDATIONS.one_capital_letter' | translate }}
      </li>
      <li
        class="list__item"
        [ngClass]="{ 'list__item--danger': minLength, 'list__item--success': !minLength }"
      >
        {{ 'VALIDATIONS.eight_characters' | translate }}
      </li>
      <li
        class="list__item"
        [ngClass]="{
          'list__item--danger': minimalOneNumber,
          'list__item--success': !minimalOneNumber
        }"
      >
        {{ 'VALIDATIONS.minimum_one_number' | translate }}
      </li>
    </ul>
  </div>
</div>
